"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Truncate = exports.BaseTruncate = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = require("../../utils/classify");
var _TruncateModule = _interopRequireDefault(require("./Truncate.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const BaseTruncate = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    line = 1,
    showFullTextOnHover = false,
    wordBreak = 'break-all',
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("span", {
    className: (0, _classify.classify)(_TruncateModule.default.truncateLineClamp, className),
    style: {
      '--line-clamp': line,
      '--word-break': wordBreak
    },
    title: showFullTextOnHover ? children : '',
    ref: ref
  }, children);
});
exports.BaseTruncate = BaseTruncate;
const Truncate = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    children,
    line = 1,
    showFullTextOnHover = false,
    wordBreak = 'break-all',
    className: truncateClassName
  } = _ref2;
  const arrayChildren = React.Children.toArray(children);
  if (arrayChildren.length) {
    const child = arrayChildren[0];
    if ( /*#__PURE__*/React.isValidElement(child)) {
      const {
        className,
        children
      } = child.props;
      return /*#__PURE__*/React.cloneElement(child, {
        className: (0, _classify.classify)(_TruncateModule.default.truncateLineClamp, className, truncateClassName),
        style: {
          '--line-clamp': line,
          '--word-break': wordBreak
        },
        title: showFullTextOnHover ? children : '',
        ref
      });
    }
    return /*#__PURE__*/React.createElement(BaseTruncate, {
      line: line,
      showFullTextOnHover: showFullTextOnHover,
      ref: ref,
      wordBreak: wordBreak,
      className: truncateClassName
    }, children);
  }
  return null;
});
exports.Truncate = Truncate;